module.exports = __webpack_public_path__ + "img/finances-control.b0cdf80c.png";